import React, { useEffect, useState } from "react";
import axios from "axios";
import LoadingAnimation from "../LoadingAnimation";
import BillingDatePicker from "../DatePicker";
export default function Installation({
  installationDetails,
  setInstallationDetails,
  isOpenInstallation,
  setIsOpenInstallation,
  selectpreoderid,
  apiMaterials,
}) {
  const [shippingAddress, setShippingAddress] = useState(null);
  const [selectedAc, setSelectedAc] = useState([]);
  const [selectItemprice, setSelectItemprice] = useState(0);
  const [paidAmount, setPaidAmount] = useState(0);
  const [customerid, setcustomerid] = useState();
  const [shippingAddresses, setShippingAddresses] = useState([]);
  const [parentPreorder, setParentPreorder] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [childinstalltion, setchildinstalltion] = useState({});
  const [isEditing, setIsEditing] = useState(false);
  const [editBillDate, setEditBillDate] = useState(false);
  const [take3MonthPayment, setTake3MonthPayment] = useState(false);
  const selectedDate = installationDetails.customerBillingDate;


  const modelToReadable = {
    S10: "1 Ton",
    S15: "1.5 Ton",
    S20: "2 Ton",
    C20: "2 Ton",
    C30: "3 Ton",
  };






  useEffect(() => {
    if (customerid) {
      const fetchData = async () => {
        setIsLoading(true); // Start loading

        try {
          const addressResponse = await axios.get(
            `${process.env.REACT_APP_MYBACKEND_PI}/api/customer/customershipping/address/${customerid}`
          );
          setShippingAddresses(addressResponse.data || []);

          const billingResponse = await axios.get(
            `${process.env.REACT_APP_MYBACKEND_PI}/api/customer/getcustomer/details/${customerid}`
          );
          if (billingResponse.data.data.customerBillingDate) {
            setInstallationDetails((prevDetails) => ({
              ...prevDetails,
              customerBillingDate:
                billingResponse.data.data.customerBillingDate,
            }));
            setEditBillDate(true);
          }
        } catch (err) {
          console.error("Error during API calls:", err);
          setShippingAddresses([]);
        } finally {
          setIsLoading(false); // Stop loading in all cases (success or error)
        }
      };

      fetchData();
    }
  }, [customerid]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_MYBACKEND_PI}/api/preOrder/${selectpreoderid}`,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("authToken")}`,
            },
          }
        );
        const childdata = await axios.get(
          `${process.env.REACT_APP_MYBACKEND_PI}/api/preOrder/getchild/${selectpreoderid}`,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("authToken")}`,
            },
          }
        );
        const data = res.data;
        const childDocuments = childdata.data;
        // console.log(childDocuments.data)
        setParentPreorder(data);
        setchildinstalltion(childDocuments.data);
        setcustomerid(data.customer.customer_id);
        setPaidAmount(data.paidamount);
        setSelectedAc(data);
        setTake3MonthPayment(data.take3MonthPayment || false)
      } catch (err) {
        console.error(err);
      }
    };

    if (selectpreoderid) fetchData();
  }, [selectpreoderid]);

  useEffect(() => {
    if (Array.isArray(shippingAddresses) && shippingAddresses.length > 0) {
      setShippingAddress(parentPreorder.customer_shipping_address.addressid); // Default to the first address
    }
  }, [shippingAddresses]);

  useEffect(() => {
    if (childinstalltion) {
      const previouslyInstalledMaterials =
        childinstalltion.materialsdetails?.map((item) => item._id) || [];

      const previouslyInstalledACs = childinstalltion.AcDetails?.reduce(
        (acc, item) => {
          acc[item._id] = (acc[item._id] || 0) + item.quantity;
          return acc;
        },
        {}
      );

      setInstallationDetails((prev) => ({
        ...prev,
        previouslyInstalledMaterials,
        previouslyInstalledACs,
      }));
    }
  }, [childinstalltion]);





  const handleCheckboxChange = (e, acType, ac, instanceIndex) => {
    const { checked } = e.target;
    const subscriptionComponent = take3MonthPayment
    ? ac.subscription_price * 3
    : ac.subscription_price;

  const singleInstancePrice =
    subscriptionComponent + ac.deposit + ac.installation_price;
    const key = `${acType.toLowerCase()}Acs`;
    const uniqueIdentifier = `${ac._id}-${instanceIndex}`;

    if (checked && paidAmount < singleInstancePrice) {
      alert("Insufficient balance to select this AC!");
      return;
    }

    setInstallationDetails((prevInstallDetails) => {
      const currentSelectedModels = prevInstallDetails[key] || [];

      const updatedProducts = checked
        ? [...currentSelectedModels, uniqueIdentifier]
        : currentSelectedModels.filter((item) => item !== uniqueIdentifier);

      return {
        ...prevInstallDetails,
        [key]: updatedProducts,
      };
    });
    setPaidAmount((prevPaidAmount) =>
      checked
        ? prevPaidAmount - singleInstancePrice
        : prevPaidAmount + singleInstancePrice
    );
    setSelectItemprice((prevPrice) =>
      checked
        ? prevPrice + singleInstancePrice
        : prevPrice - singleInstancePrice
    );
  };
  const handleMaterialCheckboxChange = (e, material) => {
    const materialPrice = material.material_price * (material.quantity || 1); // Calculate the material price
    const updatedMaterials = [...(installationDetails.selectedMaterials || [])]; // Clone existing selected materials
    const { checked } = e.target; // Extract the checked state

    if (checked) {
      // Add material
      if (paidAmount >= materialPrice) {
        updatedMaterials.push(material._id); // Add material to the list
        setPaidAmount((prevPaidAmount) => prevPaidAmount - materialPrice); // Deduct material price
        setSelectItemprice((prevPrice) => prevPrice + materialPrice); // Increase total selected price
      } else {
        alert("Insufficient balance to add this material!");
        return; // Exit without updating state
      }
    } else {
      const index = updatedMaterials.indexOf(material._id);
      if (index > -1) {
        updatedMaterials.splice(index, 1);
        setPaidAmount((prevPaidAmount) => prevPaidAmount + materialPrice);
        setSelectItemprice((prevPrice) => prevPrice - materialPrice);
      }
    }

    setInstallationDetails((prev) => ({
      ...prev,
      selectedMaterials: updatedMaterials, // Update selected materials
    }));
  };
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setInstallationDetails((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleCloseModal = () => {
    setIsOpenInstallation(!isOpenInstallation);
    setSelectItemprice(0);
    setInstallationDetails((prevDetails) => ({
      ...prevDetails, // Keep other properties intact
      DateofInstallation: null,
      TimeofInstallation: null,
      installtioncomment: "",
      selectedMaterials: [],
      customerBillingDate: "",
      splitAcs: [],
      cassetteAcs: [],
    }));
  };

  const handleAddressChange = (value) => {
    setShippingAddress(value);
  };

  function generateTimeSlots(selectedDate) {
    const slots = [
      { start: 9, end: 12 },
      { start: 12, end: 15 },
      { start: 15, end: 18 },
      { start: 18, end: 21 },
    ];
    const now = new Date();
    const todayDate = now.toISOString().split("T")[0];
    const currentHour = now.getHours();
    if (!selectedDate) return [];
    const selectedDay = new Date(selectedDate).toISOString().split("T")[0];
    // If today, filter out past slots
    const availableSlots = slots.filter((slot) => {
      return selectedDay !== todayDate || slot.start > currentHour;
    });

    return availableSlots.map(
      (slot) => `${formatTime(slot.start)} - ${formatTime(slot.end)}`
    );
  }

  function formatTime(hour) {
    const ampm = hour >= 12 ? "PM" : "AM";
    const formattedHour = hour % 12 === 0 ? 12 : hour % 12;
    return `${formattedHour}:00 ${ampm}`;
  }
  const materialTypeMapping = apiMaterials.reduce((acc, material) => {
    acc[material.material_code] = material.material_name;
    return acc;
  }, {});

  const partialinstallation = async () => {
    try {
      const requiredFields = [
        { key: "DateofInstallation", label: "Tentative Installation Date" },
        { key: "TimeofInstallation", label: "Tentative Installation Time" },
        { key: "installtioncomment", label: "installtioncomment" },
      ];

      // Find missing fields
      const missingFields = requiredFields.filter(
        (field) => !installationDetails[field.key]
      );

      if (missingFields.length > 0) {
        const missingFieldNames = missingFields
          .map((field) => field.label)
          .join(", ");
        alert(
          `⚠️ Please fill out the following required fields before submitting the request: ${missingFieldNames}. 😟`
        );
        return;
      }
      const selectedMaterialDetails = parentPreorder.materialsdetails.filter(
        (material) =>
          installationDetails.selectedMaterials?.includes(material._id)
      );

      const mapAcs = (acs) =>
        (acs || [])
          .map((ac) => {
            const [acId] = ac.split("-");
            const acDetail = parentPreorder.AcDetails.find(
              (ac) => ac._id === acId
            );
            return acDetail ? { ...acDetail, quantity: 1 } : null;
          })
          .filter((ac) => ac !== null);
      const splitAcDetails = mapAcs(installationDetails.splitAcs);
      const cassetteAcDetails = mapAcs(installationDetails.cassetteAcs);
      const selectedAddress = shippingAddresses.find(
        (address) => address._id === shippingAddress
      );
      if (!selectedAddress) {
        alert("Selected address not found!");
        return;
      }
      const acDetails = [...splitAcDetails, ...cassetteAcDetails];
      if (!acDetails.length && !selectedMaterialDetails.length) {
        alert("Please select at least one AC or material.");
        return;
      }
      setIsLoading(true);
      const newdata = {
        customer: parentPreorder.customer,
        superAdmin: parentPreorder.superAdmin,
        brandName: parentPreorder.brandName,
        executive_id: parentPreorder.executive_id,
        DateofInstallation: installationDetails.DateofInstallation,
        TimeofInstallation: installationDetails.TimeofInstallation,
        installtioncomment: installationDetails.installtioncomment,
        productSelection: installationDetails.productSelection,
        customerBillingDate: installationDetails.customerBillingDate,
        materialsdetails: selectedMaterialDetails,
        AcDetails: acDetails,
        customer_shipping_address: {
          address_line1: selectedAddress.line1,
          address_line2: selectedAddress.line2,
          pincode: selectedAddress.pincode,
          city: selectedAddress.city,
          state: selectedAddress.state,
          country: "India",
          contactPerson: selectedAddress.contactPerson,
          contactNumber: selectedAddress.contactNumber,
          addressid: selectedAddress._id,
        },
        Ac_totalAmount: acDetails.reduce((total, ac) => {
          const subscriptionTotal = ac.subscription_price * (ac.quantity || 1);
          const installationTotal = ac.installation_price * (ac.quantity || 1);
          const depositTotal = ac.deposit * (ac.quantity || 1);
          return total + subscriptionTotal + installationTotal + depositTotal;
        }, 0),
        material_totalAmount: selectedMaterialDetails.reduce(
          (total, material) => {
            return total + material.material_price * material.quantity;
          },
          0
        ),
        customer_billing_address: parentPreorder.customer_billing_address,
        selectproductAmount: selectItemprice,
        pending_amount: 0,
        paidamount: selectItemprice,
        customoerBillingDate: installationDetails.customerBillingDate,
        orderingStatus: true,
        preOrdertimestamp: new Date(),
      };
      let cassetteInstallationCharge = null;
      let splitInstallationCharge = null;
      acDetails.forEach((item) => {
        if (
          cassetteInstallationCharge === null &&
          item.ac_type.toLowerCase() === "cassette"
        ) {
          cassetteInstallationCharge = item.installation_price;
        }
        if (
          splitInstallationCharge === null &&
          item.ac_type.toLowerCase() === "split"
        ) {
          splitInstallationCharge = item.installation_price;
        }
      });
      const baseURL =
        process.env.REACT_APP_MYBACKEND_PI || "http://localhost:8080";

      const response = await axios.put(
        `${baseURL}/api/preOrder/partial/installtion/${parentPreorder._id}`,
        {
          newdata,
          parentPreorder,
          selectedAddress,
          cassetteInstallationCharge,
          splitInstallationCharge,
          installationDetails,
          acDetails,
          apiMaterials
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("authToken")}`, // Add token here
          },
        }
      );
      if (!editBillDate) {
        const billDateUpdate = await axios.put(
          `${baseURL}/api/customerprofile/billingdate/${parentPreorder.customer.customer_id}`,
          { customerBillingDate: installationDetails.customerBillingDate }
        );
      }

      if (response.status === 200) {
        alert(`${response.data.message}`);
        setIsLoading(false);
        handleCloseModal();
      } else {
        console.error("Unexpected response:", response.data);
        setIsLoading(false);
        handleCloseModal();
      }
    } catch (error) {
      if (error.response) {
        console.error("Error response:", error.response.data);
        alert(`Error: ${error.response.data.message || "An error occurred"}`);
        setIsLoading(false);
        handleCloseModal();
      } else {
        console.error("Error:", error.message);
        alert("Network error or server unreachable.");
        setIsLoading(false);
        handleCloseModal();
      }
    }
  };

  return (
    <>
      {isOpenInstallation && (
        <>
          <div
            className="fixed inset-0 bg-black bg-opacity-50 z-50 flex justify-center items-center overflow-y-auto "
            onClick={handleCloseModal}
          >
            <div
              className="bg-white shadow-md rounded-xl border-2 p-4 max-w-lg w-full relative  max-h-[85vh]"
              onClick={(e) => e.stopPropagation()} // Prevent closing when clicking inside
            >
              <button
                className="absolute top-2 right-2 text-gray-500 hover:text-gray-700"
                onClick={handleCloseModal}
              >
                ✖️
              </button>
              <h1 className="font-medium text-base mb-4">
                Installation Details
              </h1>
              {/* Amount Details */}
              <div className="flex justify-between mb-4">
                <div className="text-sm">
                  <p>Amount for selected items</p>
                  <p className="font-bold text-lg">₹ {selectItemprice}</p>
                </div>
                <div className="text-sm">
                  <p>Paid amount</p>
                  <p className="font-bold text-lg">₹ {paidAmount}</p>
                </div>
              </div>
              <div className="mt-4 overflow-y-auto max-h-[400px]">
                <div className="grid grid-cols-2 gap-4">
                  {/* Date Input */}
                  <div>
                    <label
                      htmlFor="DateofInstallation"
                      className="block text-sm font-medium mb-1"
                    >
                      Requested Installation Date
                    </label>
                    <input
                      type="date"
                      id="DateofInstallation"
                      name="DateofInstallation"
                      className="w-full border border-gray-300 rounded px-2 py-1 text-sm"
                      value={installationDetails.DateofInstallation}
                      onChange={handleInputChange}
                      min={new Date().toISOString().split("T")[0]} // Restricts to today or future dates
                      required
                    />
                  </div>
                  <div>
                    <label
                      htmlFor="TimeofInstallation"
                      className="block text-sm font-medium mb-1"
                    >
                      Requested Installation Time
                    </label>
                    <select
                      id="TimeofInstallation"
                      name="TimeofInstallation"
                      className="w-full border border-gray-300 rounded px-2 py-1 text-sm"
                      value={installationDetails.TimeofInstallation || ""} // Default to empty string
                      onChange={handleInputChange}
                      disabled={!installationDetails.DateofInstallation} // Disable dropdown if no date is selected
                      required
                    >
                      <option value="" disabled>
                        -- Select a time slot --
                      </option>
                      {installationDetails.DateofInstallation &&
                        generateTimeSlots(
                          installationDetails.DateofInstallation
                        ).map((slot, index) => (
                          <option key={index} value={slot}>
                            {slot}
                          </option>
                        ))}
                    </select>
                  </div>
                </div>
                {!isEditing && selectedDate ? (
                  // Display input if customerBillingDate already exists
                  <div className="mt-4">
                    <label
                      htmlFor="customerBillingDate"
                      className="block text-sm font-medium mb-1"
                    >
                      Customer Billing Date
                    </label>
                    <input
                      type="text"
                      id="customerBillingDate"
                      name="customerBillingDate"
                      className="w-full border border-gray-300 rounded px-2 py-1 text-sm"
                      // value={`${installationDetails.customerBillingDate}th of Each Month`}
                      value={`${new Date(
                        selectedDate
                      ).getDate()}th of Each Month`}
                      readOnly // Make input read-only since date is pre-filled
                    />
                    {!editBillDate ? (
                      <button
                        type="button"
                        className={
                          "w-10 mt-1 rounded py-1 text-sm bg-primary text-white"
                        }
                        onClick={() => setIsEditing(true)} // Enable editing
                      >
                        Edit
                      </button>
                    ) : null}
                  </div>
                ) : (
                  <BillingDatePicker
                    installationDetails={installationDetails}
                    handleInputChange={(e) => {
                      handleInputChange(e); // Update parent state
                      setIsEditing(false); // Exit edit mode after selection
                    }}
                  />
                )}

                <div className="mt-4">
                  <label
                    htmlFor="siteAddress"
                    className="block text-sm font-medium mb-1"
                  >
                    Site Address:
                  </label>
                  <select
                    value={shippingAddress}
                    name="siteAddress"
                    onChange={(e) => handleAddressChange(e.target.value)}
                    className="w-full border border-gray-300 rounded px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-primary resize-none appearance-none"
                  >
                    <option value="" disabled>
                      Select a site address...
                    </option>
                    {Array.isArray(shippingAddresses) &&
                      shippingAddresses.length > 0 ? (
                      shippingAddresses.map((address, index) => (
                        <option
                          key={index}
                          value={address._id}
                          style={{
                            whiteSpace: "pre-wrap",
                          }}
                        >
                          {`${address.line1}\n${address.pincode}\n${address.city}\n${address.state}`}
                        </option>
                      ))
                    ) : (
                      <option value="" disabled>
                        No addresses available
                      </option>
                    )}
                  </select>
                </div>
                <div className="mt-4 ">
                  {/* <label className="block text-sm font-medium mb-1">Products:</label>
                                    <div className="flex items-center mb-2">
                                        <input
                                            type="radio"
                                            id="customProducts"
                                            name="productSelection"
                                            value="custom"
                                            checked={installationDetails.productSelection === 'custom'}
                                            onChange={handleInputChange}
                                            className="ml-4 mr-2"
                                        />
                                        <label htmlFor="customProducts" className="text-sm">Custom</label>
                                    </div> */}

                  {/* Scrollable Materials Selection */}
                  <label className="block text-sm font-medium mb-1">
                    Materials:
                  </label>
                  {selectedAc.materialsdetails?.length > 0 ? (
                    selectedAc.materialsdetails.map((material, index) => {
                      const isChecked =
                        installationDetails.selectedMaterials?.includes(
                          material._id
                        ) || false;
                      return (
                        <div
                          key={index}
                          className={`flex items-center  p-2 rounded ${isChecked ? "bg-green-100" : "bg-white"
                            } transition-colors duration-300`}
                        >
                          <input
                            type="checkbox"
                            id={`material-${material._id}`}
                            checked={isChecked}
                            onChange={(e) =>
                              handleMaterialCheckboxChange(e, material)
                            }
                            disabled={installationDetails.previouslyInstalledMaterials?.includes(
                              material._id
                            )} // Disable if already installed
                            className="mr-2"
                          />
                          <label
                            htmlFor={`material-${material._id}`}
                            className="text-sm"
                          >
                            {`${materialTypeMapping[material.material_name] ||
                              "Unknown Material"
                              } - Qty: ${material.quantity || 0}`}
                          </label>
                        </div>
                      );
                    })
                  ) : (
                    <p className="text-sm text-gray-500">
                      No materials available.
                    </p>
                  )}

                  {selectedAc
                    ? ["Split", "Cassette"].map((acType) => (
                      <div key={acType} className="mt-4">
                        <label className="block text-sm font-medium mb-2">
                          {acType} ACs:
                        </label>
                        <div className="grid grid-cols-2 gap-4">
                          {selectedAc.AcDetails &&
                            Array.isArray(selectedAc.AcDetails) &&
                            selectedAc.AcDetails.filter(
                              (item) => item.ac_type === acType
                            ).map((item) => {
                              // Calculate installed quantity and remaining quantity
                              const installedCount =
                                installationDetails.previouslyInstalledACs?.[
                                item._id
                                ] || 0;
                              const remainingQuantity =
                                item.quantity - installedCount;

                              return [...Array(item.quantity)].map(
                                (_, instanceIndex) => {
                                  const uniqueId = `${item._id}-${instanceIndex}`;
                                  const isChecked =
                                    installationDetails[
                                      `${acType.toLowerCase()}Acs`
                                    ]?.includes(uniqueId) || false;
                                  const isDisabled =
                                    instanceIndex >= remainingQuantity; // Disable if instanceIndex exceeds remaining quantity

                                  return (
                                    <div
                                      key={uniqueId}
                                      className={`flex items-center  rounded ${isChecked ? "bg-blue-100" : "bg-white"
                                        } ${isDisabled
                                          ? "opacity-50 cursor-not-allowed"
                                          : ""
                                        } transition-colors duration-300`}
                                    >
                                      <input
                                        type="checkbox"
                                        id={`${acType}-${uniqueId}`}
                                        checked={isChecked}
                                        onChange={(e) =>
                                          handleCheckboxChange(
                                            e,
                                            acType,
                                            item,
                                            instanceIndex
                                          )
                                        }
                                        disabled={isDisabled}
                                        className="mr-2"
                                      />
                                      <label
                                        htmlFor={`${acType}-${uniqueId}`}
                                        className="text-sm"
                                      >
                                        {`${acType} ${modelToReadable[item.model] ||
                                          item.model
                                          }`}
                                      </label>
                                    </div>
                                  );
                                }
                              );
                            })}
                        </div>
                      </div>
                    ))
                    : null}
                </div>
                <div className="mt-4">
                  <label
                    htmlFor="installtioncomment"
                    className="block text-sm font-medium mb-1"
                  >
                    Comment:
                  </label>
                  <textarea
                    value={installationDetails.installtioncomment || ""}
                    onChange={handleInputChange}
                    name="installtioncomment"
                    placeholder="Add your comments here..."
                    className="w-full border border-gray-300 rounded px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-primary"
                  ></textarea>
                </div>
              </div>
              <button
                onClick={partialinstallation}
                className={
                  "w-full mt-4 rounded py-2 text-sm bg-primary text-white"
                }
              >
                Request Installation
              </button>
            </div>
          </div>
          {isLoading && (
            <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex justify-center items-center overflow-y-auto ">
              <LoadingAnimation />
            </div>
          )}
        </>
      )}
    </>
  );
}
